import React, { memo, Component } from 'react'
import CountUp from 'react-countup';

export class Counter extends Component {    
    render() {
        return (
            // <!-- Counter Start -->
            <div className="section techwix-counter-section-02">
                <div className="container">
                    <div className="counter-wrap">
                        <div className="row">
                            {
                                this.props.ms ?
                                    this.props.ms.map((item, number) =>

                                        <div key={number} className="col-xl-3 col-md-6">                                            
                                            {item.id === 4 ?
                                                <div className="single-counter single-counter-4">
                                                    <div className="counter-img">
                                                        <img src={item.milestone_icon} alt="" />
                                                    </div>
                                                    <div className="counter-content">
                                                        <CountUp start={0} end={item.milestone_number} startOnMount={false} enableScrollSpy={true} scrollSpyDelay={200}>
                                                            {({ countUpRef }) => (
                                                                <span className="counter" ref={countUpRef} />
                                                            )}
                                                        </CountUp>
                                                        <span className="counter" >/</span>
                                                        <CountUp start={0} end={7} startOnMount={false} enableScrollSpy={true} scrollSpyDelay={200}>
                                                            {({ countUpRef }) => (
                                                                <span className="counter" ref={countUpRef} />
                                                            )}
                                                        </CountUp>
                                                        <p>{item.milestone_text}</p>
                                                    </div>
                                                </div> : item.id === 3 ?
                                                <div className="single-counter single-counter-4">
                                                    <div className="counter-img">
                                                        <img src={item.milestone_icon} alt="" />
                                                    </div>
                                                    <div className="counter-content">
                                                        <CountUp start={0} end={item.milestone_number} startOnMount={false} enableScrollSpy={true} scrollSpyDelay={200}>
                                                            {({ countUpRef }) => (
                                                                <span className="counter" ref={countUpRef} />
                                                            )}
                                                        </CountUp>
                                                        <span className="counter" >%</span>
                                                        
                                                        <p>{item.milestone_text}</p>
                                                    </div>
                                                </div> :
                                                <div className="single-counter">
                                                    <div className="counter-img">
                                                        <img src={item.milestone_icon} alt="" />
                                                    </div>
                                                    <div className="counter-content">
                                                        <CountUp start={0} end={item.milestone_number} startOnMount={false} enableScrollSpy={true} scrollSpyDelay={200}>
                                                            {({ countUpRef }) => (
                                                                <span className="counter" ref={countUpRef} />
                                                            )}
                                                        </CountUp>
                                                        <p>{item.milestone_text}</p>
                                                    </div>
                                                </div>

                                            }

                                        </div>

                                    )
                                    : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
            // <!-- Counter End --> 
        )
    }
}

export default memo(Counter)